
import BannerContainer from '~/components/child/banner/BannerContainer.vue';
import TagContainer from '~/components/child/tag/TagContainer.vue';
import RecipeContainer from '~/components/child/recipe/RecipeContainer.vue';
import BrowseContainer from '~/components/child/browse/BrowseContainer.vue';
import ArticleChannelContainer from '~/components/child/article/ArticleChannelContainer.vue';
import BloggerRankingChannel from '~/components/child/blogger/BloggerRankingChannel.vue';
import ArticleHotContainer from '~/components/child/article/ArticleHotContainer.vue';
export default {
    name: "travel",
    components: { BannerContainer, TagContainer, RecipeContainer, BrowseContainer, ArticleChannelContainer, BloggerRankingChannel, ArticleHotContainer },
    head() {
        return {
            title: '健康-PIXNET痞客邦',
            meta: [
                { hid: 'description', name: 'description', content: '你可以和來自世界各地的朋友們分享、學習和探討關於健康的各種常識和資訊。無論你對健身、營養、心理健康還是生活習慣有什麼問題或想法，這裡都有豐富的內容和經驗等待你的探索。加入痞客邦健康頻道，和一群關心健康的人們一起努力，共同追尋健康的生活方式。快來參與，讓我們一起建立一個充滿正能量的健康社群吧！' },
                { hid: 'og:description', name: 'og:description', property: 'og:description', content: '你可以和來自世界各地的朋友們分享、學習和探討關於健康的各種常識和資訊。無論你對健身、營養、心理健康還是生活習慣有什麼問題或想法，這裡都有豐富的內容和經驗等待你的探索。加入痞客邦健康頻道，和一群關心健康的人們一起努力，共同追尋健康的生活方式。快來參與，讓我們一起建立一個充滿正能量的健康社群吧！' },
                { hid: 'twitter:description', name: 'twitter:description', property: 'twitter:description', content: '你可以和來自世界各地的朋友們分享、學習和探討關於健康的各種常識和資訊。無論你對健身、營養、心理健康還是生活習慣有什麼問題或想法，這裡都有豐富的內容和經驗等待你的探索。加入痞客邦健康頻道，和一群關心健康的人們一起努力，共同追尋健康的生活方式。快來參與，讓我們一起建立一個充滿正能量的健康社群吧！' },
                { hid: 'keywords', name: 'keywords', content: '健康飲食、運動鍛煉、心理健康、睡眠品質、自然療法、健康管理、營養補充、預防疾病、心靈療癒、健康生活方式' },
                { hid: 'og:title', name: 'og:title', property: 'og:title', content: "健康-PIXNET痞客邦"},
                { property: 'og:image', property: 'og:image', content: "https://www.pixnet.net/img/public/og/img_heathly_og.png"},
                { property: 'og:image:secure_url', property: 'og:image:secure_url', content: "https://www.pixnet.net/img/public/og/img_heathly_og.png"},
                { property: 'twitter:image', property: 'twitter:image', content: "https://www.pixnet.net/img/public/og/img_heathly_og.png"},
                { property: 'image', name: 'image', itemprop: 'image', content: "https://www.pixnet.net/img/public/og/img_heathly_og.png"},
            ],
            link: [
                { rel: 'canonical', href: 'https://www.pixnet.net/channel/health', key: "canonical"}
            ]
        }
    },
    jsonld() {
        return {
            "@context": " https://schema.org/",
            "@graph": [
                {
                    "@context":"https://schema.org",
                    "@type":"Organization",
                    "url":"https://www.pixnet.net",
                    "logo":"https://www.pixnet.net/img/public/og/img_heathly_og.png",
                    "name":"痞客邦",
                    "@id":"https://www.pixnet.net/#organization",
                    "description":"你可以和來自世界各地的朋友們分享、學習和探討關於健康的各種常識和資訊。無論你對健身、營養、心理健康還是生活習慣有什麼問題或想法，這裡都有豐富的內容和經驗等待你的探索。加入痞客邦健康頻道，和一群關心健康的人們一起努力，共同追尋健康的生活方式。快來參與，讓我們一起建立一個充滿正能量的健康社群吧！",
                    "address":"",
                    "brand":{
                        "@type":"Brand",
                        "logo":"https://www.pixnet.net/img/public/og/img_heathly_og.png"
                    },
                    "sameAs":"https://www.facebook.com/pixnet.net"
                },
                {
                    "@context":"https://schema.org/",
                    "@type":"BreadcrumbList",
                    "itemListElement":[
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "健康-PIXNET痞客邦",
                            "item": "https://www.pixnet.net",
                            "description": "你可以和來自世界各地的朋友們分享、學習和探討關於健康的各種常識和資訊。無論你對健身、營養、心理健康還是生活習慣有什麼問題或想法，這裡都有豐富的內容和經驗等待你的探索。加入痞客邦健康頻道，和一群關心健康的人們一起努力，共同追尋健康的生活方式。快來參與，讓我們一起建立一個充滿正能量的健康社群吧！",
                            "keywords": "健康飲食、運動鍛煉、心理健康、睡眠品質、自然療法、健康管理、營養補充、預防疾病、心靈療癒、健康生活方式"
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            channel_page_id: 7,
            showAnimation: false,
        }
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        pa_page_name() {
            return '健康';
        },
        tag_search_text() {
            return '健康';
        },
        day_hot_article() {
            return this.$store.state.article.day_hot_article;
        },
        day_hot_article_full() {
            return this.$store.state.article.day_hot_article_full;
        }
    },
    methods: {
        paFunction() {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::頁面::page::user_action', '', '']);
        },
        paScrollFunction(){
            addEventListener("scroll", () => {
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'scroll::頁面::page::user_action', '', '']);
            }, { once: true });
        },
        gtag(){
            window.dataLayer.push(arguments);
        },
        activeGaPage() {
            this.gtag('config', 'G-RPGK0ML6QM', {
                'channel_category': '健康'
            });
            this.gtag('config', 'G-45SMZ66RLZ', {
                'channel_category': '健康'
            });
            this.gtag('event', 'page_view', {
                page_title: '健康-PIXNET痞客邦',
            });
        },
        activeMcPage() {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kbvat69or6");
        },
    },
    async fetch(){
        const item = { sort: 'hot', type: 'group', pre_page: 10, id: 7, ver: 2 }
        await this.$store.dispatch("article/getDayHotArticle", item);
    },
    mounted() {
        window.dataLayer = window.dataLayer || [];
        this.activeGaPage();
        this.activeMcPage();
        this.paFunction();
        this.paScrollFunction();
    }
}
